// extracted by mini-css-extract-plugin
export default {"terms__main__text":"termsText_terms__main__text__VAXzg"};